import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { TargetGroupList } from "../targetGroups/TargetGroupList";

export const TargetGroupPage: FC = () => {
	return (
		<Routes>
			<Route index element={<TargetGroupList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
